import { Alert, Button, Paper, Snackbar, TextField, Typography } from '@mui/material'
import React,{useEffect, useState} from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { db } from '../../firebase';

import { Editor, EditorTools } from "@progress/kendo-react-editor";
import "@progress/kendo-theme-default/dist/all.css";

function TicketView({ticket, onClose}) {
    const [fname,setFn]= useState(ticket.firstName)
    const [lname,setLn]= useState(ticket.lastName)
    const [email,setEmail]= useState(ticket.email)
    const [mobile,setMobile]= useState(ticket.mobile)
    const [subj,setSubj]= useState(ticket.subject)
    const [desc,setDesc]= useState(ticket.desc)
    const [subj_a,setSubjA]= useState(ticket.ticketId)
    const [msg,setMsg]= useState('')
    const [alert, setAlert] = React.useState(null);
    const [templates, setTemplates] = useState([]);
    const [selected, setSelect] = useState('')

  useEffect(() => {
    // fetch templates from Firestore on component mount
    const unsubscribe = db.collection('temp')
      .onSnapshot((querySnapshot) => {
        const templateData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
        setTemplates(templateData);
      });

    return () => {
      // unsubscribe from Firestore listener on component unmount
      unsubscribe();
    };
  }, []);

  return (
    <div style={{display:'flex',gap:'2rem'}}>
     <Snackbar
                    open={Boolean(alert)}
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                    autoHideDuration={8000} 
                    onClose={() => setAlert(null)}
                >
                    <Alert
                        onClose={() => setAlert(null)} 
                        severity="success"
                        variant="filled"
                    >
                        {alert}
                    </Alert>
                </Snackbar>
    <Paper style={{width:'40%',padding:'2rem'}}>
    <Typography variant='h5' style={{}}>{ticket.ticketId}</Typography>
    <TextField
        label='First Name'
        fullWidth
        value={fname}
        disabled
    />
    <br/>
    <br/>
     <TextField
        label='Last Name'
        fullWidth
         value={lname}
        disabled
    />
     <br/>
     <br/>
     <TextField
        label='E-mail'
        fullWidth
         value={email}
        disabled
    />
     <br/>
     <br/>
     <TextField
        label='Mobile'
        fullWidth
         value={mobile}
        disabled
    />
     <br/>
     <br/>
     <TextField
        label='Subject'
        fullWidth
         value={subj}
        disabled
    />
     <br/>
     <br/>
     <p>Description</p>
     <textarea
        style={{width:'100%',height:'100px'}}
         value={desc}
        disabled
    />
    </Paper>
    <Paper style={{width:'40%',padding:'2rem'}}>
    <div style={{display:'flex', justifyContent:'space-between'}}><b>Response to {ticket.ticketId}</b> 

    <CancelIcon
    style={{cursor:'pointer'}}
        onClick={onClose}
    /></div>
     <TextField
        label='To'
        fullWidth
        value={email}
        disabled
    />
    <br/>
    <br/>
     <TextField
        label='From'
        fullWidth
        value={'admin@tritek.co.uk'}
        disabled
    />
    <br/>
    <br/>
     <TextField
        label='Subject'
        fullWidth
        value={subj_a}
        onChange={(e)=>{setSubjA(e.target.value)}}
    />
    <br/>
    <br/>
    <p>Response:</p>
     <Editor
              contentStyle={{ height: 200,width:'100%' }}
              onChange={(event) => setMsg(event.html)}
              value={msg}
            />
    <div style={{display:'flex',justifyContent:'space-between'}}> 
    <div style={{width:'40%',marginTop:'1rem'}}>
        <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Select Template</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label="Select Template"
          onChange={(e)=>{
            db.collection('temp').doc(e.target.value).get().then((snapshot)=>{
            let data = snapshot.data().desc
                setMsg(data)
            })
           
            }}
        >
          {templates.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            {template.title}
          </MenuItem>
        ))}
        </Select>
      </FormControl>
    </div>
    <SendIcon style={{fontSize:'2rem',cursor:'pointer'}}
         onClick={()=>{db.collection('tickets').doc(ticket.id).update({
        status:'closed'
       })
    setAlert('Email sent successfully')
    }}
    /></div>
    <Button variant={'contained'} style={{background:'red',marginTop:'2rem'}} 
    onClick={()=>{db.collection('tickets').doc(ticket.id).update({
        status:'closed'
    })
    setAlert('Ticket Closed')
    }}
    >Close Ticket</Button>
    </Paper>
    </div>
  )
}

export default TicketView